<script setup>
  import { log } from '@/services/log'
  import { ref, inject, computed, watch } from 'vue'
  import { useAuthStore } from '@/stores/auth'
  import { NButton, NForm, NGrid, NFormItemGi, NInput, NFlex, NH4, NModal } from 'naive-ui'

  const appStoreFn = inject('appStoreFn')
  const appStore = appStoreFn()
  const authStore = useAuthStore()

  const apiService = inject('apiService')
  const formElementRef = ref(null)

  const formData = ref({
    password: null,
    confirmPassword: null,
    userName: null,
    currentPassword: null,
  })
  const formRules = {
    password: [
      {
        required: true,
        message: 'Please enter a new password',
        trigger: 'blur',
      },
    ],
    userName: [
      {
        required: true,
        message: 'Please enter username',
        trigger: 'blur',
      },
    ],
    confirmPassword: [
      {
        required: true,
        message: 'Please confirm password',
        trigger: 'blur',
      },
    ],
    currentPassword: [
      {
        required: true,
        message: 'Please enter current password',
        trigger: 'blur',
      },
    ],
  }

  const checkValidUser = async (row) => {
    if (isSelfReset.value) {
      const obj = {
        username: formData.value.userName,
        password: formData.value.currentPassword,
      }
      const result = await apiService.requestPost('/login', obj)
      if (result?.success) {
        submitForm(row)
      } else {
        log('Your Current Password do not match')
      }
    } else {
      submitForm(row)
    }
  }
  const isSelfReset = computed(() => authStore?.user?.username === appStore?.userResetInfo?.username)

  const submitForm = async (row) => {
    try {
      const isValid = await formElementRef.value.validate()
      if (isValid) {
        await apiService.requestPost(`users/${row.externalId}/reset`, {
          password: formData.value.password,
          confirmPassword: formData.value.confirmPassword,
          userName: formData.value.userName,
        })
        appStore.showResetPasswordModal = false
        formData.value.userName = null
        formData.value.password = null
        formData.value.currentPassword = null
        formData.value.confirmPassword = null
      }
    } catch (error) {
      log('Password reset failed', error)
    }
  }
  watch(
    () => appStore.showResetPasswordModal,
    (isVisible) => {
      if (isVisible) {
        formData.value['userName'] = appStore.userResetInfo.username
      }
    }
  )
</script>
<template>
  <NModal
    v-model:show="appStore.showResetPasswordModal"
    preset="dialog"
    title="Reset Password"
    :closable="true"
  >
    <NFlex vertical>
      <NH4>Reset Password for {{ appStore.userResetInfo.name }}</NH4>
      <div class="grow">
        <NForm
          ref="formElementRef"
          :rules="formRules"
          :model="formData"
        >
          <NGrid
            :span="24"
            :x-gap="24"
          >
            <NFormItemGi
              path="userName"
              label="Username"
              span="18"
            >
              <NInput
                readonly
                v-model:value="formData.userName"
                placeholder="Enter username"
              />
            </NFormItemGi>
            <NFormItemGi
              path="currentPassword"
              label="Current Pasword"
              span="18"
            >
              <NInput
                v-model:value="formData.currentPassword"
                placeholder="Enter your current password"
                type="password"
              />
            </NFormItemGi>
            <NFormItemGi
              path="password"
              label="New Pasword"
              span="18"
            >
              <NInput
                v-model:value="formData.password"
                placeholder="Enter new password"
                type="password"
              />
            </NFormItemGi>
            <NFormItemGi
              v-if="formData.password !== null && formData.password !== ''"
              path="confirmPassword"
              label="Confirm Password"
              span="18"
            >
              <NInput
                v-model:value="formData.confirmPassword"
                placeholder="Confirm password"
                type="password"
              />
            </NFormItemGi>
          </NGrid>
        </NForm>
      </div>
      <NButton
        id="resetFormSaveBtn"
        type="success"
        class="mx-1 my-1"
        @click="checkValidUser(appStore.userResetInfo)"
      >
        Reset Password
      </NButton>
    </NFlex>
  </NModal>
</template>
